/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) System Track Icon component.
 */
export const SystemTrackIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M11.52 22.04C17.33 22.04 22.04 17.33 22.04 11.52C22.04 5.70996 17.33 1 11.52 1C5.70996 1 1 5.70996 1 11.52C1 17.33 5.70996 22.04 11.52 22.04Z' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' />
      <path d='M7.02979 11.71L14.0598 7L12.8698 15.37L10.3898 12.72L7.02979 11.71Z' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
};

export default SystemTrackIcon;
